import styled from 'styled-components';
import React from 'react';
import colors from '../../../../helpers/colors';
import Facebook from "../../../../resources/images/social-icons/facebook.svg";
import Linkedin from "../../../../resources/images/social-icons/linkedin.svg";
import Twitter from "../../../../resources/images/social-icons/twitter.svg";

const Container = styled.div`
    display: flex;
    border-bottom: 1px solid ${colors.dividerLightGrey};
    
    @media screen and (max-width: 1280px) {
        display: none;
    }
`;

const ShareIconWrapper = styled.a`
    height: 43px;
    margin: 38px 5px 32px 5px;
`;


const ShareIcons = ({ url }) => {
    return (
        <Container>
             <ShareIconWrapper
                href={`https://www.facebook.com/sharer/sharer.php?u=www.motivosity.com/blog${url}/`}
                target="_blank"
                rel="noopener"
            >
            <img src={Facebook} alt={"Share via Facebook"} />
                
            </ShareIconWrapper>
            
            <ShareIconWrapper
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://motivosity.com/blog${url}/`}
                target="_blank"
                rel="noopener"
            >
            <img src={Linkedin} alt={"Share via Linkedin"} />
            </ShareIconWrapper>

            <ShareIconWrapper
                href={`https://twitter.com/intent/tweet?text=www.motivosity.com/blog${url}/`}
                target="_blank"
                rel="noopener"
            >
            <img src={Twitter} alt={"Share via Twitter"} />
            </ShareIconWrapper> 
        </Container>
    );
};

export default ShareIcons;
